<template>
  <div class="component-interaction pl-2 pr-2">
    <!-- <div id="top-header">
      <div class="decoration-content">
        <div class="flex items-center">
          <div
            class="flex items-center justify-center"
            style="height: 100%; width: 100%"
          >
            民政为民
          </div>
        </div>
      </div>
      <div class="decoration-content">
        <div class="flex items-center">
          <div class="flex items-center justify-center" style="height: 100%">
            民政爱民
          </div>
        </div>
      </div>
      <div class="center-title cursor-pointer" @click="goBack">
        <img class="logo" src="../../assets/imgs/dadukou-logo.jpg" alt="" />
        大渡口区社区居家智慧养老服务平台
      </div>
    </div> --> 
    <ComponentTopHeader @onBack="goBack"></ComponentTopHeader>
    <div class="main-container">
      <div class="left-container mr-2">
        <LeftContainer
          :data="list[0]"
          @onChangePage="onChangePage"
        ></LeftContainer>
      </div>
      <div class="center-container">
          <CenterContainer :data="list[1]" @onChangePage="onChangePage"></CenterContainer>
      </div>
      <div class="right-container ml-2">
        <RightContainer1></RightContainer1>
        <RightContainer2 :data="list[2]"></RightContainer2>
      </div>
    </div>
  </div>
</template>
<script>
import LeftContainer from "./components/LeftContainer.vue";
import CenterContainer from "./components/CenterContainer.vue";
import RightContainer1 from "./components/RightContainer1";
import RightContainer2 from "./components/RightContainer2";
import ComponentTopHeader from "../../components/datav/TopHeader.vue";

export default {
  data() {
    return {
      list: [
        {
          list: [],
        },
      ],
      query: {
        page: 1,
        pageSize: 7,
      },
    };
  },
  components: {
    LeftContainer,
    CenterContainer,
    RightContainer1,
    RightContainer2,
    ComponentTopHeader,
  },
  methods: {
    goBack() {
      this.$store.dispatch("app/changeMapCount", 0);
      this.$store.dispatch("app/initAddress");
      // this.$store.dispatch("app/getGlobalData", { key: "" });

      this.$router.go(-1);
    },
    async onChangePage(query) {
      let index = query.index;
      this.list[index].query.page = query.page;
      let response = await this.getArticleList(query);
      this.list[index].list = response.list;
      this.list[index].index = index;
    },
    getArticleList(params) {
      return new Promise((resolve) => {
        this.$axios
          .get("/articleService/open/article/paginate", {
            params,
          })
          .then((resp) => {
            resolve(resp.data);
          });
      });
    },
    getList() {
      this.$axios
        .get("/articleService/open/domain/list", {
          params: {
            typeIds: "2,3,4",
            mechanismId: "M57wVRNZ",
            // mechanismId: "Xwlg97rP",
          },
        })
        .then(async (resp) => {
          let list = resp.data;
          if (list.length > 4) {
            list = list.slice(0, 4);
          }
          for (let i = 0; i < list.length; i++) {
            let response = await this.getArticleList({
              moduleId: list[i].moduleId,
              ...this.query,
              pageSize: i == 1 ? 5: this.query.pageSize
            });
            response.list.sort((a, b) => {
              return b.sort - a.sort;
            });
            list[i].name = response.list[0].modules[0].name;
            list[i].list = response.list;
            list[i].query = { ...this.query, moduleId: list[i].moduleId };
            list[i].total = response.total;
            list[i].index = i;
            if(i == 1) {
              list[i].query.pageSize = 5;
            }
          }
          this.list = list;
          console.log("list", this.list);
        });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style lang="less" scoped>
.component-interaction {
  height: 100%;
  //   background: #eef0f3;
  background: @background-color;
  background-image: url("../../components/datav/img/bg.png");
  background-size: 100% 100%;
  // background: linear-gradient(95deg, #abd1e7, #abd1e7);
  // ::v-deep {
  //   .el-card {
  //     color: #abd1e7 !important;

  //     border: 1px solid #4bace0;
  //   }
  //   .el-card__header {
  //     border-bottom: 1px solid #4bace0;
  //   }
  // }
  .main-container {
    display: flex;
    height: calc(100% - 170px);
    .left-container,
    .right-container {
      flex: 1;
      background: rgba(0, 0, 0, 0);
    }
    .center-container {
      width: 50%;
      background: rgba(0, 0, 0, 0);
    }
  }
}
</style>
